// src/utils/complexityCalculator.js

export const calculateComplexity = (type, det, ftr, ret) => {
  det = Number(det);
  ftr = Number(ftr);
  ret = Number(ret);

  // =======================
  // EI / EO / EQ
  // =======================
  if (["EI", "EO", "EQ"].includes(type)) {
    let detLevel = det <= 5 ? 1 : det <= 15 ? 2 : 3;
    let ftrLevel = ftr <= 1 ? 1 : ftr <= 3 ? 2 : 3;

    // MATRIX EI/EO/EQ
    const matrix = {
      1: { 1: "ต่ำ", 2: "ต่ำ", 3: "กลาง" },
      2: { 1: "ต่ำ", 2: "กลาง", 3: "สูง" },
      3: { 1: "กลาง", 2: "สูง", 3: "สูง" }
    };

    return matrix[ftrLevel][detLevel];
  }

  // =======================
  // ILF / EIF
  // =======================
  if (["ILF", "EIF"].includes(type)) {
    let detLevel = det <= 19 ? 1 : det <= 50 ? 2 : 3;
    let retLevel = ret === 1 ? 1 : ret <= 5 ? 2 : 3;

    // MATRIX ILF/EIF
    const matrix = {
      1: { 1: "ต่ำ", 2: "ต่ำ", 3: "กลาง" },
      2: { 1: "ต่ำ", 2: "กลาง", 3: "สูง" },
      3: { 1: "กลาง", 2: "สูง", 3: "สูง" }
    };

    return matrix[retLevel][detLevel];
  }

  return "";
};
